import { render, staticRenderFns } from "./multiselect-input.vue?vue&type=template&id=1a294971&scoped=true"
import script from "./multiselect-input.ts?vue&type=script&lang=ts&external"
export * from "./multiselect-input.ts?vue&type=script&lang=ts&external"
import style0 from "./multiselect-input.vue?vue&type=style&index=0&id=1a294971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a294971",
  null
  
)

export default component.exports